import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaSeedling,
  FaLeaf,
  FaFlask,
  FaRupeeSign,
  FaHandshake
} from "react-icons/fa";

const reasons = [
  {
    icon: <FaSeedling />,
    title: "Farmer-Centric Approach",
    text: "Our products are developed by understanding real farming challenges and field-level needs.",
  },
  {
    icon: <FaLeaf />,
    title: "Eco-Friendly Solutions",
    text: "Formulations designed to protect soil health, water resources, and natural ecosystems.",
  },
  {
    icon: <FaFlask />,
    title: "Field-Tested Performance",
    text: "Every solution is evaluated under real farm conditions for reliable and visible results.",
  },
  {
    icon: <FaRupeeSign />,
    title: "Cost-Effective Productivity",
    text: "Higher crop output while keeping cultivation costs under control for farmers.",
  },
  {
    icon: <FaHandshake />,
    title: "Trusted Support System",
    text: "Strong partnerships with farmers, dealers, and distributors for consistent guidance.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section why-section">
      <Container>

        {/* Section Heading (Common CSS) */}
        <div className="section-title fade-up">
          <h2>Why Choose Hindustan Agro Life</h2>
          <p>
            The difference farmers experience through responsibility, performance,
            and long-term agricultural commitment.
          </p>
        </div>

        <Row>
          {reasons.map((item, index) => (
            <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
              <div className="why-card">
                <div className="why-icon">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default WhyChooseUs;
